<template>
  <div class="pie-content">
    <div class="flex-between">
      <div v-if="item.title" class="title-2">{{ item.title }}</div>
      <slot>
        <div v-if="item.showTagList" class="flex-align-center tag-list">
          <div
            v-for="(item, index) in timeTagList"
            :key="index"
            :class="{ 'tag-item': true, 'active-tag': tagItemIndex == index }"
            @click="toggleTagItem(index)"
          >
            {{ item.label }}
          </div>
        </div>
      </slot>
    </div>
    <!-- 副标题-->
    <div v-if="item.subTitle && item.rate != undefined" class="sub-title flex-align-center">
      <span>{{ item.subTitle }}</span>
      <span class="rate">{{ item.rate }}%</span>
    </div>
    <div style="width: 100%" class="flex-between">
      <PieChart
        :color="['#009DFF', '#13B999', '#FA9600', '#EB3D2F']"
        style="flex: 1; height: 240px"
        :radius="['45%', '60%']"
        :dataSource="item.chartData"
        :pieText="item.pieText"
        :label="customLabel"
      />
      <div v-if="!item.hideLegend" :style="legendStyle">
        <div
          v-for="(cItem, cIndex) in item.legendArr || item.chartData"
          :key="cIndex"
          class="legend-item flex-between"
          :class="{'disabled': cItem.loading}"
          @click="goDetail(item, cItem, cIndex)"
        >
          <div class="legend-text-area">
            <div class="flex-align-center">
              <img
                v-if="cItem.icon"
                :src="require(`@assets/${cItem.icon}.png`)"
                alt=""
                style="width: 13px; height: 15px; margin: 0 4px 4px 0"
              />
              <div>
                {{ cItem.name }}
              </div>
            </div>
            <div v-if="cItem.text" style="color: #fa5a25">
              {{ cItem.text }}
            </div>
          </div>
          <span style="font-size: 22px; color: #333; font-weight: bold">
            <CountAnimation :end-val="cItem.value" :style="{ color: cItem.color }" />
          </span>
          <span
            class="right-icon flex-center"
            :style="{ background: !cItem.isNotHasDetail ? '#d7d9d9' : '' }"
          >
            <a-icon
              v-if="!cItem.isNotHasDetail"
              type="right"
              style="font-size: 14px; color: #fff"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountAnimation from '@/components/CountAnimation'
import PieChart from '@/components/echartZyz/components/PieChart'

export default {
  name: 'PieChartCard',
  components: { CountAnimation, PieChart },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    legendStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      timeTagList: [
        {
          label: '本周',
          value: 'week',
        },
        {
          label: '本月',
          value: 'month',
        },
        {
          label: '本学期',
          value: 'term',
        },
        {
          label: '全部',
          value: 'all',
        },
      ],
      tagItemIndex: 0,
      customLabel: {
        formatter: (params) => {
          return params.name + ': ' + params.value.toLocaleString()
        },
      },
    }
  },
  methods: {
    toggleTagItem(index) {
      this.tagItemIndex = index
      this.$emit('refresh', this.timeTagList[index].value)
    },
    goDetail(item, cItem, cIndex) {
      // 没有path路径和单项path路径、或没有详情（isNotHasDetail：true）时，禁止跳转页面
      if ((!cItem.path && !item.path) || cItem.isNotHasDetail) return
      const query = {
        ...(item.query || {}),
        ...(cItem?.query || {}),
        index: cItem?.type || cIndex + 1,
      }
      if (this.tagItemIndex) {
        query.timeType = this.timeTagList[this.tagItemIndex].value
      }
      this.$router.push({
        path: cItem.path || item.path,
        query,
      })
    },
  },
}
</script>

<style scoped lang="less">
.pie-content {
  box-sizing: border-box;
  width: 100%;
  height: 350px;
  padding: 20px 30px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: #fff;
  .tag-list {
    .tag-item {
      width: 54px;
      height: 24px;
      margin: 6px;
      line-height: 24px;
      text-align: center;
      background: #eff4fc;
      border-radius: 4px;
      color: #404040;
      font-size: 12px;
      cursor: pointer;
    }
    .active-tag {
      background: #009dff;
      color: #fff;
    }
  }
  .sub-title {
    margin-top: 10px;
    font-size: 14px;
    color: #666666;
    .rate {
      margin-left: 5px;
      font-size: 18px;
      font-weight: 600;
      color: #009dff;
    }
  }
  .legend-item {
    width: 250px;
    padding: 5px 20px;
    background-color: #f8fafc;
    border-radius: 8px;
    margin: 15px 0;
    cursor: pointer;
    &:hover {
      background-color: #eef2f7;
    }
    &.active {
      background-color: #eef2f7;
    }
    &.disabled {
      cursor: not-allowed;
      background-color: #f8fafc;
      color: #999999;
      pointer-events: none;
    }
    .legend-text-area {
      display: inline-block;
      width: 80px;
      font-size: 13px;
      color: #666;
      letter-spacing: 0.17px;
    }
    .right-icon {
      width: 16px;
      height: 16px;
      border-radius: 50%;
    }
  }
}
</style>
